import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

import { LOCALE_PREFIX } from './constants'

import HocDialogComponent from '../../../../services/dialog/hocDialogComponent'
import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
@HocDialogComponent
export default class Confirm extends Component {
    static propTypes = {
        closeDialog: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        onButtonClick: PropTypes.func.isRequired,
        settings: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
    }

    onButtonClick = (buttonType) => {
        const { type, id, closeDialog, onButtonClick, settings } = this.props

        onButtonClick(buttonType, id)
        if (!settings?.manualClose) closeDialog(type, id)
    }

    onCloseClick = () => {
        const {
            settings: { buttons, closeButton },
        } = this.props

        const button = closeButton || _.last(buttons) || null
        if (button) this.onButtonClick(button)
    }

    defineHeader = () => {
        const {
            settings: {
                header: { textId, icon, values },
            },
        } = this.props

        return {
            text: (
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.title.${textId}`}
                    values={{
                        ...values,
                        b: (chunks) => <b>{chunks}</b>,
                        strong: (chunks) => <strong>{chunks}</strong>,
                        br: <br />,
                        span: (chunks) => <span style={{ color: '#dc0000' }}>{chunks}</span>,
                    }}
                />
            ),
            icon,
        }
    }

    defineFooter = () => {
        const {
            settings: { buttons }, id
        } = this.props

        return _.map(buttons, (button) => {
            const buttonObject = _.isPlainObject(button) ? button : { key: button }

            return {
                type: buttonObject.key,
                text: <FormattedMessage id={`${LOCALE_PREFIX}.button.${buttonObject.key}`} />,
                color: buttonObject.color || null,
                name: id+'-'+buttonObject.key,
            }
        })
    }

    render() {
        const {
            settings: {
                question: { textId, values },
            },
        } = this.props

        return (
            <div className={'confirm-dialog'}>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.text.${textId}`}
                    values={{
                        ...values,
                        b: (chunks) => <b>{chunks}</b>,
                        strong: (chunks) => <strong>{chunks}</strong>,
                        br: <br />,
                        span: (chunks) => <span style={{ color: '#dc0000' }}>{chunks}</span>,
                        atel: (chunks) => <a href="mailto:podpora.cz@dnb.com">{chunks}</a>,
                        amail: (chunks) => <a href="mailto:podpora.cz@dnb.com">{chunks}</a>,
                        acia: (chunks) => (
                            <a
                                href="https://www.cianews.cz/vseobecne-obchodni-podminky"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {chunks}
                            </a>
                        ),
                        aciagdpr: (chunks) => (
                            <a
                                href="https://www.cianews.cz/zasady-ochrany-osobnich-udaju"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {chunks}
                            </a>
                        ),
                    }}
                />
            </div>
        )
    }
}
